import { createSelector } from 'reselect';

const selectRewardPoints = (state: any) => state.rewardPoints;


export const selectRewardPointCurrentItem = createSelector([selectRewardPoints], (rewardPoints) => rewardPoints.current);

export const selectRewardPointsListItems = createSelector([selectRewardPoints], (rewardPoints) => rewardPoints.list);

export const selectRewardPointItemById = (itemId: any) =>
    createSelector(selectRewardPointsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectRewardPointQueryItems = createSelector([selectRewardPoints], (rewardPoints) => rewardPoints.query);

export const selectRewardPointCreatedItem = createSelector([selectRewardPoints], (rewardPoints) => rewardPoints.create);

export const selectRewardPointUpdatedItem = createSelector([selectRewardPoints], (rewardPoints) => rewardPoints.update);

export const selectRewardPointReadItem = createSelector([selectRewardPoints], (rewardPoints) => rewardPoints.read);

export const selectRewardPointDeletedItem = createSelector([selectRewardPoints], (rewardPoints) => rewardPoints.delete);

export const selectRewardPointSearchedItems = createSelector([selectRewardPoints], (rewardPoints) => rewardPoints.search);

export const selectRewardPointItemsCount = createSelector([selectRewardPoints], (rewardPoints) => rewardPoints.count);

export const selectRewardPointItemsFilter = createSelector([selectRewardPoints], (rewardPoints) => rewardPoints.filter);